/**
 * Whether PostHog has been identified as the authenticated user.
 *
 * Its own module — deliberately free of auth/expo imports — so route GATES can
 * read the signal without pulling the auth barrel (and `expo-device` with it)
 * into their module graph.
 *
 * Flag gates must wait for this. Before identify, PostHog evaluates `/flags`
 * for the ANONYMOUS distinct id, so a user-targeted flag resolves to a real
 * `false` rather than `undefined`. A gate that only treats `undefined` as
 * "loading" therefore decides on the anonymous answer — which is why a hard
 * refresh on a flag-gated route bounced the user to Home (SE-6233).
 * @module hooks/posthogIdentityStore
 */
import { makeVar, useReactiveVar } from "@apollo/client";

/** `true` once identify + the post-identify flag reload have settled. */
export const posthogIdentifiedVar = makeVar(false);

/**
 * Reads whether PostHog has identified the authenticated user.
 * @returns `true` once identify + the flag reload have settled
 */
export const usePostHogIdentified = (): boolean =>
  useReactiveVar(posthogIdentifiedVar);
